import ServiceAccordion from "../components/ServiceAccordion.jsx";
import { useAwsConfig } from '../../../../../context/Dashboard/aws/contextConfig.js';
import { useParams } from "react-router-dom";

export default function ServiceModuleAws() {
  const service_name = useParams().service;
  const { cAwsConfigAll : data } = useAwsConfig();
  const serviceData = data.services[service_name];
  
  return (
    <div className="container py-4">
      <div className="mb-4 fw-semibold text-dark text-capitalize">
        {service_name} Dashboard
      </div>

      <ServiceAccordion 
        findings={serviceData?.findings} 
        regions={serviceData?.regions}
      />
    </div>
  );
}
